const reportsRoutes = [
  {
    path: '/:prefix(test)?/reports',
    name: 'ReportsList',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      title: 'Reportes'
    },
    component: () => import('@/modules/reports/views/ReportsList')
  },
  {
    path: '/:prefix(test)?/reports/sales-report',
    name: 'SalesReportDetail',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      title: 'Detalle de Ventas Diarias'
    },
    component: () => import('@/modules/reports/views/SalesReportDetail')
  }
]
export default reportsRoutes
